module.exports = "/_next/static/images/75ac1fe0d6fafc384ea457b2a712af70-nuconta-inclined-device@0.5x.png.webp";